"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  // PORTAL EMAIL SEND CREDITS
  FETCH_PORTAL_EMAIL_SEND_CREDITS_START: null,
  FETCH_PORTAL_EMAIL_SEND_CREDITS_SUCCESS: null,
  FETCH_PORTAL_EMAIL_SEND_CREDITS_FAIL: null,
  // PORTAL STATUS like suspension status
  REQUEST_PORTAL_STATUS: null,
  RECEIVE_PORTAL_STATUS: null,
  REQUEST_PORTAL_DISMISS_STATUS: null,
  RECEIVE_PORTAL_DISMISS_STATUS: null,
  REQUEST_SUSPENSION_APPEAL: null,
  RECEIVE_SUSPENSION_APPEAL: null,
  RECEIVE_UPDATE_PORTAL_DISMISS_STATUS: null,
  REQUEST_UPDATE_PORTAL_DISMISS_STATUS: null,
  // RSS URL FEED VALIDATION
  FETCH_RSS_URL_FEED_VALIDATION_START: null,
  FETCH_RSS_URL_FEED_VALIDATION_SUCCESS: null,
  FETCH_RSS_URL_FEED_VALIDATION_FAIL: null,
  RESET_RSS_FEED_URL_VALIDATION: null,
  // BLOG EMAILS
  FETCH_BLOG_EMAILS_START: null,
  FETCH_BLOG_EMAILS_SUCCESS: null,
  FETCH_BLOG_EMAILS_FAIL: null,
  RESET_BLOG_EMAILS: null,
  // EMAIL ADDRESS OWNERSHIP
  FETCH_FROM_ADDRESSES_START: null,
  FETCH_FROM_ADDRESSES_SUCCESS: null,
  FETCH_FROM_ADDRESSES_FAIL: null,
  ADD_EMAIL_ADDRESS_STARTED: null,
  ADD_EMAIL_ADDRESS_SUCCEEDED: null,
  ADD_EMAIL_ADDRESS_FAILED: null,
  ADD_EMAIL_ADDRESS_RESET: null,
  REMOVE_EMAIL_ADDRESS_STARTED: null,
  REMOVE_EMAIL_ADDRESS_SUCCEEDED: null,
  REMOVE_EMAIL_ADDRESS_FAILED: null,
  REMOVE_EMAIL_ADDRESS_RESET: null,
  ADD_CUSTOM_REPLY_TO: null,
  // TODO remove
  REMOVE_CUSTOM_REPLY_TO: null,
  // TODO remove
  FROM_ADDRESS_VERIFICATION_EMAIL_SENT: null,
  FROM_ADDRESS_VERIFIED: null,
  START_POLLING_FROM_ADDRESSES: null,
  STOP_POLLING_FROM_ADDRESSES: null,
  UPDATE_CUSTOM_REPLY_TO_FAIL: null,
  // SMART INSIGHTS
  FETCH_SMART_INSIGHTS_START: null,
  FETCH_SMART_INSIGHTS_SUCCESS: null,
  FETCH_SMART_INSIGHTS_FAIL: null,
  FETCH_SMART_INSIGHTS_RESET: null,
  // TEST SEND
  ADD_TEST_SEND_ADDRESS: null,
  TEST_SEND_ITEM_SUCCESS: null,
  TEST_SEND_ITEM_FAIL: null,
  TEST_SEND_RESET: null,
  TEST_SEND_MODAL_TOGGLE: null,
  TEST_SEND_FINISHED: null,
  TEST_EMAIL_SEND_START: null,
  TEST_EMAIL_RENDER_START: null,
  TEST_EMAIL_RENDER_FAIL: null,
  // PORTAL DND SETUP STATUS
  RECEIVE_PORTAL_SETUP_STATUS: null,
  REQUEST_PORTAL_SETUP_STATUS: null
});

exports.default = _default;
module.exports = exports.default;